var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoonBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 26,
    viewBox: "0 0 74 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_793_17806)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_793_17806)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 25.6533,
    rx: 12.8267,
    fill: "url(#paint0_linear_793_17806)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5607 -4.55503C33.3233 -4.74311 33.0727 -4.78697 32.9662 -4.80436C32.3617 -4.90312 32.0503 -4.51937 31.8049 -4.6892C31.6213 -4.81629 31.7706 -5.04438 31.5864 -5.45943C31.5661 -5.50515 31.3223 -6.03314 30.7589 -6.24533C30.2921 -6.42111 29.8578 -6.28533 29.6825 -6.23054C29.0198 -6.02332 28.8181 -5.57485 28.5869 -5.67585C28.3821 -5.76529 28.4867 -6.13451 28.277 -6.7384C28.2339 -6.86264 28.0581 -7.33857 27.6859 -7.7171C27.4591 -7.94768 27.2002 -8.10024 26.9497 -8.20099C25.9631 -7.75636 25.0346 -7.19235 24.1644 -6.54522C23.2017 -5.8294 22.0676 -6.24135 20.9545 -6.13476C20.187 -6.06121 19.5359 -5.6638 18.9357 -5.20526C18.6593 -4.99406 18.5172 -4.77529 18.2968 -4.51639C18.2414 -4.45142 18.147 -4.32085 18.0488 -4.29526C17.8271 -4.23724 17.4781 -4.40868 17.2035 -4.54931C17.2669 -4.35588 17.3858 -4.2565 17.356 -4.22171C17.3224 -4.18258 17.163 -4.29811 16.94 -4.37775C16.6717 -4.47353 16.4441 -4.46844 16.3025 -4.46781C16.1939 -4.46732 15.7493 -4.45576 15.313 -4.19214C15.3037 -4.18655 15.2899 -4.1781 15.2722 -4.16705C15.1848 -4.11176 14.4058 -3.59968 14.4093 -2.79143C14.4113 -2.32133 14.6775 -1.87584 15.0192 -1.63445C15.4117 -1.35704 15.64 -1.53556 16.4205 -1.22449C16.8843 -1.03963 16.8306 -0.965959 17.2566 -0.806694C17.8835 -0.572392 18.4297 -0.57115 18.7491 -0.573386C19.15 -0.576119 19.6129 -0.579226 20.1569 -0.782842C20.7606 -1.0087 21.1152 -1.35071 21.5729 -1.21095C21.6933 -1.17417 21.6989 -1.13715 21.8896 -1.07951C21.9896 -1.04932 22.3275 -0.954779 22.7716 -0.98857C23.5098 -1.04472 23.6806 -1.38984 24.1815 -1.43829C24.7606 -1.49432 25.06 -1.01242 25.6117 -0.78545C27.5567 0.0144806 30.3166 -0.430768 31.1158 -1.73707C31.2708 -1.9905 31.2987 -2.18902 31.5553 -2.3832C32.1776 -2.85379 32.8826 -2.35425 33.5361 -2.83143C33.5987 -2.87715 33.9781 -3.1635 34.0126 -3.62316C34.0525 -4.15413 33.603 -4.52161 33.5607 -4.55503Z",
    fill: "#F2F7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1425 -4.21268C32.6445 -4.49742 32.0866 -4.31691 31.9126 -4.26063C31.3755 -4.08683 31.3995 -3.83663 30.9853 -3.77737C30.5064 -3.70879 30.3982 -4.03242 29.9087 -3.97005C29.4586 -3.91278 29.4297 -3.61897 28.9534 -3.55114C28.6227 -3.50406 28.5738 -3.63661 27.9798 -3.74184C27.7338 -3.78544 27.1921 -3.87675 26.5701 -3.7606C26.321 -3.71401 25.9469 -3.61338 25.5241 -3.36976C25.3838 -3.14478 25.0699 -2.62772 24.4374 -2.39268C23.956 -2.21378 23.3981 -2.16546 22.8921 -2.19887C22.535 -2.22248 21.0246 -2.41529 20.8656 -2.99595C20.3876 -2.61468 19.8909 -2.22322 19.2854 -2.0898C18.9844 -2.02346 18.3411 -1.88991 17.6854 -2.22372C17.3722 -2.38311 17.1629 -2.59542 17.039 -2.74425C16.8652 -2.66114 16.5473 -2.5425 16.1565 -2.58374C15.2229 -2.68251 14.768 -3.60034 14.7338 -3.67239C14.6323 -3.52965 14.4426 -3.22081 14.4095 -2.79146C14.4008 -2.67928 14.3547 -1.90631 14.9728 -1.37571C15.5681 -0.864621 16.2929 -0.996183 16.3828 -1.0142C16.6013 -0.821388 17.5092 -0.0654359 18.8776 -0.0741324C20.4222 -0.0839467 21.3883 -1.06053 21.5591 -1.23943C21.6353 -1.16104 22.1549 -0.64473 22.9633 -0.688832C23.7351 -0.730947 24.1862 -1.2521 24.26 -1.34018C24.5568 -1.15855 25.0133 -0.908103 25.6039 -0.698275C26.2082 -0.483601 28.4462 0.311236 30.4839 -0.797287C30.8486 -0.995686 31.4092 -1.36515 31.9515 -2.04433C32.7164 -1.7817 33.4693 -2.07377 33.7113 -2.58946C33.8923 -2.9752 33.7749 -3.45908 33.5832 -3.77227C33.5312 -3.85675 33.4 -4.06546 33.1425 -4.21268Z",
    fill: "#CEEAF0"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.13067,
    cy: 34.7307,
    rx: 26.8373,
    ry: 19.9307,
    fill: "url(#paint1_linear_793_17806)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.688,
    cy: 5.42674,
    r: 0.296,
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.9093,
    cy: 5.82136,
    r: 0.296,
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.2479,
    cy: 21.2134,
    r: 0.296,
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.8801,
    cy: 4.04539,
    r: 0.296,
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.3147,
    cy: 9.57072,
    r: 0.296,
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.4347,
    cy: 14.7014,
    r: 0.296,
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.264,
    cy: 21.608,
    r: 0.296,
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.2667,
    cy: 12.136,
    r: 0.296,
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.99204,
    cy: 8.3867,
    r: 0.296,
    fill: "#C7C7C7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_793_17806",
    x: -0.394667,
    y: 0,
    width: 74.3947,
    height: 26.4427,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.394667,
    dy: 0.789333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.38133
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_793_17806"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_793_17806",
    x1: 10.98,
    y1: 30.8827,
    x2: 75.403,
    y2: 3.27366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#041326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E314C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_793_17806",
    x1: 5.13067,
    y1: 14.8,
    x2: 5.13067,
    y2: 54.6613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C2F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151F25"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_793_17806"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 25.7007,
    rx: 12.8504,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonBg);
export default __webpack_public_path__ + "static/media/moonBg.2572afc1b51cce89792b73797718d7b5.svg";
export { ForwardRef as ReactComponent };